import EntityController from "../../entity/_controller/EntityController";
import {ENTITY_CONFIG} from "../../entity/_model/entity.constants";

class AudienceController extends EntityController {

}

export default new AudienceController(ENTITY_CONFIG.AUDIENCE);
